module.exports = __webpack_public_path__ + "static/img/logo.b378802e.png";